let isPageLeft = false;

if (typeof window !== "undefined") {
    window.addEventListener("pagehide", () => {
        isPageLeft = true;
    });
    window.addEventListener("pageshow", () => {
        isPageLeft = false;
    });
}

/**
 * Whether `pagehide` has fired: the page is being navigated away from, closed
 * or put in the back-forward cache. Chromium then rejects the page's keepalive
 * requests even though they still reach the server.
 */
export function hasPageBeenLeft(): boolean {
    return isPageLeft;
}

/**
 * Calls `onSettled(true)` once `pagehide` fires, or `onSettled(false)` after
 * `timeoutMs`. WebKit cancels the page's requests as a navigation starts, while
 * `pagehide` fires only once the next page answers.
 */
export function whenPageLeftWithin(timeoutMs: number, onSettled: (isLeft: boolean) => void): void {
    if (isPageLeft || typeof window === "undefined") {
        onSettled(isPageLeft);
        return;
    }

    const onPageHide = () => {
        clearTimeout(timer);
        onSettled(true);
    };
    const timer = setTimeout(() => {
        window.removeEventListener("pagehide", onPageHide);
        onSettled(false);
    }, timeoutMs);
    window.addEventListener("pagehide", onPageHide, { once: true });
}
